import React, { useState } from 'react';
import { TextField, Button, InputAdornment } from '@mui/material';

const CommentInput = ({ onSubmit, currentUser }) => {
  const [comment, setComment] = useState('');

  const handleCommentChange = (event) => {
    setComment(event.target.value);
  };

  const handleSubmit = () => {
    if (comment.trim() !== '' && currentUser) {
      onSubmit(comment);
      setComment('');
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <TextField
      fullWidth
      label="댓글 추가"
      variant="outlined"
      value={comment}
      onChange={handleCommentChange}
      onKeyPress={handleKeyPress}
      margin="normal"
      disabled={!currentUser}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <Button
              onClick={handleSubmit}
              color="primary"
              disabled={!currentUser || comment.trim() === ''}
              sx={{ height: '100%', minWidth: 0, p: '8px' }}
            >
              작성
            </Button>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default CommentInput;
